// Allow ColumnsMap to be accessed as an object too
export class ColumnsMap extends Map {
  constructor(iterable){
    super();
    const columns = new Map(iterable);
    return new Proxy(columns, columnMapAccessorProxy);
  }
}
// Proxy handler to implement ColumnsMap type
const columnMapAccessorProxy = {
  get: function(target, prop, receiver) {
    // Map instance methods/properties that could plasubily be column names:
    if ([
      'clear',
      'delete',
      'keys',
      'set',
      'values',
      'size'
    ].includes(prop)) {
      return target.get(prop);
    }
    const value = Reflect.get(target, prop, receiver);
    if (typeof value === 'function') return value.bind(target);
    if (prop === Symbol.iterator) return target[Symbol.iterator].bind(target);
    if (value === undefined) return target.get(prop);
    return value;
  },
  set: function(target, prop, value) {
    target.set(prop, value);
    return true;
  },
  has: function(target, prop) {
    return Reflect.has(target, prop);
  },
  ownKeys: function(target) {
    return Array.from(target.keys());
  },
  getOwnPropertyDescriptor: function(target, prop) {
    return {
      enumerable: true,
      configurable: true,
      value: target.get(prop)
    };
  }
};
//# sourceMappingURL=columns.js.map